import React, { memo } from "react";
import useHomeSection from "./index.hooks";
import { Box, Container, Typography } from "@material-ui/core";
import AppButton from "../AppButton";
import mockupImg from "assets/images/OnePlus_MockUp_ByAmritPalSingh.png";

type HomeSectionProps = {};

const HomeSection = ({}: HomeSectionProps) => {
  const { styles, classes, atomicStyles, t } = useHomeSection();

  return (
    <>
      <div data-section="home" className={styles.fakeSection} />
      <div className={styles.section}>
        <Container className={styles.container} maxWidth="lg">
          <Box className={styles.content}>
            <Typography className={styles.title} variant="h1" gutterBottom>
              {t("Fai crescere la tua attivit\u00E0 con Adhesion")}
            </Typography>
            <Typography className={styles.subtitle} variant="h6" gutterBottom>
              {t(
                "Richiama istantaneamente i tuoi clienti e offri loro le tue promozioni",
              )}
            </Typography>
            <Box py={5}>
              <AppButton isCta path="/signup/">
                {t("Inizia")}
              </AppButton>
            </Box>
          </Box>
          <img src={mockupImg} alt="mockup" className={styles.image} />
        </Container>
      </div>
    </>
  );
};

export default memo(HomeSection);
